import type { FaireProductEntity } from "../../entity_types/product";

export const p_yh7qtquf3s: FaireProductEntity = {
  token: "p_yh7qtquf3s",
  type: "product",
  name: "My Dog Is My Therapist Gym Crew Socks - Dog Lover Gift",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/5966a4e6d68d5e98c5b7fb62f485bc159abaf7e518a7a735173c165ddd48a34a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2434f6b4ecedd1c53d6b462dfb2c0ed2e0e6e4b9d777570513349756279fac3f.jpeg",
    "https://cdn.faire.com/fastly/639eaa41b8ce6de9231ed0c5c9f2e78d6b2a5e3cbc586ad340e2adec6be88e70.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/264800a2b8a1877f8532c2d782ee8ca639d303e9706506398a0eafe0beb10b4a.jpeg",
    "https://cdn.faire.com/fastly/71ff851da855ccb53508d0a6754c4603eead7fbb2da5601e16f823cb502eb1b5.jpeg"
  ],
  priceDollars: 6.75,
  description: "After a long stressful day, there's no better therapist than your best bud. They offer a variety of treatments, including wagging their tail whenever they see you, rolling over and asking for belly rubs, or pushing their wet little nose into you so as to say \"hi, I love you\". There is no better therapist than your dog, so get some socks to celebrate your hero 🐶 .\n\nA must-have gift for dog lovers and pet parents—these witty crew socks are perfect for shops that carry dog-themed merch, pet accessories, or feel-good gifts.\n\nKey features of these gym socks:\n\n• Unisex sizing\n• One size fits most \n• Comfy cushion foot\n• No toe seam\n• Made with high quality cotton in the USA\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:53.858Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
